module.exports = __webpack_public_path__ + "static/img/viewbg.ccb56c8c.png";